import { close, toggle } from "./toggle";

type Inputs = {
  rootElement: HTMLElement;
  toggleElement: HTMLElement;
  menuElement: HTMLElement;
};

export function initDropdown({ rootElement, toggleElement, menuElement }: Inputs): void {
  toggleElement.addEventListener("click", (e) => {
    e.stopPropagation();
    toggle(menuElement);
  });

  document.addEventListener("click", (e) => {
    if (!rootElement.contains(e.target as Node)) close(menuElement);
  });

  menuElement.addEventListener("click", (e) => {
    if ((e.target as HTMLElement).closest("a")) close(menuElement);
  });
}
